import DarkLogoTxt from './logo-long-dark.svg';
import LightLogoTxt from './logo-long.svg';
import LogoMarkDarkSvg from './logo-mark-dark.svg';
import LogoMarkSvg from './logo-mark.svg';
import RunningPersonSvg from './running-person.svg?react';

export const RunningPersonIcon = RunningPersonSvg;

export const TextLogo = {
  dark: DarkLogoTxt,
  light: LightLogoTxt,
};

/** Collapsed sidebar brand mark (the Solink “O”), 28×28. */
export const LogoMark = {
  dark: LogoMarkDarkSvg,
  light: LogoMarkSvg,
};
